import { apiSlice } from './apiSlice'

export const countrySlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getIndividualCompanyDetails: builder.query({
      query: (id: string) => ({
        url: `/companies/${id}/basic_info`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
  }),
})

export const { useGetIndividualCompanyDetailsQuery } = countrySlice
